import { render } from "./HomeOrdersIcon.vue?vue&type=template&id=52930327"
import script from "./HomeOrdersIcon.vue?vue&type=script&lang=js"
export * from "./HomeOrdersIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__